import { defineMessages } from 'react-intl';

const messages = defineMessages({
  imageAlt: {
    id: '',
    description: 'Alt for file loading',
    defaultMessage: 'Loading Image',
  },
  details: {
    id: '',
    description: 'Copy shown while saving back a file is being sent and saved back to Dropbox',
    defaultMessage: 'We\'re preparing a preview of {filename}',
  },
  inProgress: {
    id: '',
    description: 'Copy of file in-progress',
    defaultMessage: 'in-progress',
  },
  savingBack: {
    id: '',
    description: 'Title when the user waits for the signature request to be sent',
    defaultMessage: 'Sending signature request...',
  },
  selfSignsavingBack: {
    id: '',
    description: 'Title when the user waits for the self-sign signature request to be saved',
    defaultMessage: 'Saving signed copy...',
  },
  sending: {
    id: '',
    description: 'Alt for sending signature request image',
    defaultMessage: 'Sending Image',
  },
  signed: {
    id: '',
    description: 'Copy of file signed',
    defaultMessage: 'signed',
  },
});

export default messages;
